/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddressDto,
  AgreementMappingRequest,
  GetAgreementMappingsAddressesParams
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Map a branch and a customer address to an agreement.
 * @summary Map Agreement Branches.
 */
export const createAgreementMapping = (
    agreementMappingRequest: AgreementMappingRequest,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/addresses/agreement/mapping`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agreementMappingRequest
    },
      options);
    }
  /**
 * Get addresses that are part of an agreement mapping.
 * @summary Get Agreement Mapping Addresses.
 */
export const getAgreementMappingsAddresses = (
    agreementID: string,
    addressID: string,
    params?: GetAgreementMappingsAddressesParams,
 options?: SecondParameter<typeof apiRequest<AddressDto[]>>,) => {
      return apiRequest<AddressDto[]>(
      {url: `/addresses/agreement/${agreementID}/mappings/${addressID}/addresses`, method: 'GET',
        params
    },
      options);
    }
  export type CreateAgreementMappingResult = NonNullable<Awaited<ReturnType<typeof createAgreementMapping>>>
export type GetAgreementMappingsAddressesResult = NonNullable<Awaited<ReturnType<typeof getAgreementMappingsAddresses>>>
